import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeProblemSection from '../components/HomePage/sections/HomeProblemSection';
import MarketingPageShell from '../components/marketing/MarketingPageShell';

interface ProblemPageProps {
  onNavigate?: (view: string) => void;
}

const ProblemPage: React.FC<ProblemPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="problem"
      title={t('pages.problem.seoTitle', 'Why GoGrabJob | The Problem We Solve')}
      description={t(
        'pages.problem.seoDescription',
        'See how GoGrabJob replaces scattered job-search tools with one AI workspace for matches, ATS scores, and interview-ready applications.',
      )}
      canonical="https://www.gograbjob.com/problem"
    >
      <HomeProblemSection />
    </MarketingPageShell>
  );
};

export default ProblemPage;
